import React, { useState } from "react";
import { IoClose, IoCheckmarkCircle, IoTimeOutline } from "react-icons/io5";
import { formatDistanceToNow } from "date-fns";

const NotificationModal = ({
  isOpen,
  onClose,
  notifications,
  onMarkAsRead,
  onDeleteNotification,
}) => {
  const [loadingStates, setLoadingStates] = useState({});

  const handleMarkAsRead = async (notificationId) => {
    try {
      setLoadingStates(prev => ({ ...prev, [`read_${notificationId}`]: true }));
      await onMarkAsRead(notificationId);
    } finally {
      setLoadingStates(prev => ({ ...prev, [`read_${notificationId}`]: false }));
    }
  };

  const handleDelete = async (notificationId) => {
    try {
      setLoadingStates(prev => ({ ...prev, [`delete_${notificationId}`]: true }));
      await onDeleteNotification(notificationId);
    } finally {
      setLoadingStates(prev => ({ ...prev, [`delete_${notificationId}`]: false }));
    }
  };


  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Background overlay */}
        <div
          className="fixed inset-0 bg-gray-600/50 bg-opacity-15 transition-opacity"
          onClick={onClose}
        />

        {/* Modal panel */}
        <div className="relative inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Notifications
              </h3>
              <button
                onClick={onClose}
                className="text-gray-400 hover:text-gray-500"
              >
                <IoClose className="h-6 w-6" />
              </button>
            </div>

            <div className="max-h-[60vh] overflow-y-auto">
              {notifications.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  No notifications yet
                </div>
              ) : (
                <div className="space-y-4">
                  {notifications.map((notification) => (
                    <div
                      key={notification._id}
                      className={`p-4 rounded-lg border ${
                        notification.isRead
                          ? "bg-gray-50 border-gray-200 border-[1px] border-solid"
                          : "bg-blue-50 border-blue-200"
                      }`}
                    >
                      <div className="flex justify-between items-start">
                        <div className="flex-1">
                          <h4 className="text-sm font-medium text-gray-900">
                            {notification.title}
                          </h4>
                          <p className="mt-1 text-sm text-gray-500">
                            {notification.message}
                          </p>
                          <div className="mt-2 flex items-center text-xs text-gray-500">
                            <IoTimeOutline className="mr-1 h-4 w-4" />
                            {formatDistanceToNow(
                              new Date(notification.createdAt),
                              {
                                addSuffix: true,
                              }
                            )}
                          </div>
                        </div>
                        <div className="ml-4 flex-shrink-0 flex">
                          {!notification.isRead && (
                            <button
                              onClick={() => handleMarkAsRead(notification._id)}
                              className="mr-2 text-blue-600 hover:text-blue-800 disabled:opacity-50"
                              title="Mark as read"
                              disabled={loadingStates[`read_${notification._id}`]}
                            >
                              <IoCheckmarkCircle className={`h-5 w-5 ${loadingStates[`read_${notification._id}`] ? 'animate-pulse' : ''}`} />
                            </button>
                          )}
                          <button
                            onClick={() => handleDelete(notification._id)}
                            className="text-gray-400 hover:text-gray-600 disabled:opacity-50"
                            title="Delete notification"
                            disabled={loadingStates[`delete_${notification._id}`]}
                          >
                            <IoClose className={`h-5 w-5 ${loadingStates[`delete_${notification._id}`] ? 'animate-pulse' : ''}`} />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationModal;
